import * as React from 'react';
import { connect, useSelector } from 'react-redux';
const PdfViewer = () => {
    const selectVerifyCheckState = (state) => state.verifyCheck;
    const verifyCheckState = useSelector(selectVerifyCheckState);
    let base64 = 'data:application/pdf;base64,' + verifyCheckState.siteDraftCheck.authorizationReceiptBase64;
    console.log('PDF');
    console.log(base64);
    return React.createElement("iframe", { src: base64, width: "100%", height: "1200px" });
};
export default connect()(PdfViewer);
//# sourceMappingURL=PdfViewer.js.map